import React from 'react';

const StepTerms = ({ accepted, setAccepted, onSubmit, submitting, bookingFee }) => {
  const terms = [
    'We do NOT provide any movies/OTT accounts. We will do the setup using your OTT account/downloaded content.',
    'Smoking/Drinking is NOT allowed inside the theater.',
    'Any DAMAGE caused to the theater, including decorative materials like balloons, lights etc. will have to be reimbursed.',
    'Guests are required to maintain CLEANLINESS inside the theater.',
    'Party poppers/Snow spray/Cold fire, and any other similar items are strictly prohibited inside the theater.',
    'Carrying AADHAAR CARD is mandatory. It will be verified during entry.',
    'Couples under 18 years of age are not allowed to book the theater.',
    'Pets are strictly not allowed inside the theater.',
    bookingFee
      ? `We collect an advance amount of \u20b9${bookingFee} plus convenience fee to book the slot.`
      : 'We collect an advance amount to book the slot.',
    'Kids above 10 yrs of age are fully chargeable while those between 3 to 10 yrs are charged half the rate.',
  ];

  const refundPolicy =
    'Advance amount is fully refundable if it is cancelled at least 72 hrs before the slot time. If your slot is less than 72 hrs away from time of payment then advance is non-refundable.';

  return (
    <section className="booking-card terms-card">
      <h4 className="booking-section-title">Terms &amp; Conditions</h4>
      <ol className="terms-list">
        {terms.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ol>

      <h4 className="booking-section-title">Refund policy</h4>
      <p className="note">{refundPolicy}</p>

      <label className="terms-checkbox">
        <input type="checkbox" checked={accepted} onChange={(e) => setAccepted(e.target.checked)} />
        <span>I agree to the above terms &amp; conditions.</span>
      </label>

      <button
        className="btn-next-step"
        type="button"
        disabled={!accepted || submitting}
        onClick={onSubmit}
      >
        {submitting ? 'Processing...' : `Pay ${bookingFee ? `\u20b9${bookingFee}` : ''} and book`}
      </button>
    </section>
  );
};

export default StepTerms;
